import React from "react";
import City from "./City"


class CityList extends React.Component {
  constructor(props) {
    super(props);
  }


  render() {
    let {onClick} = this.props;
    return this.props.cityList.map((city, index) => {
      //console.log(li)
      return (
          <City key={index} index={index} onClick={onClick} cityCode={city.code} cityName={city.name} />
      );
    });
  }
}

export default CityList;